import React from 'react';
export const TranscriptSearchViewContext = React.createContext({});
export function useTranscriptSearchViewContext() {
    return React.useContext(TranscriptSearchViewContext);
}
